"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineMissingDataToOnSelect = exports.getIsContainsLocation = exports.convertCoordinatesToLatLng = exports.getLatLngCoordinates = exports.getAddressGeocode = void 0;
var use_places_autocomplete_1 = require("use-places-autocomplete");
var getAddressGeocode = function (address, prediction) { return __awaiter(void 0, void 0, void 0, function () {
    var results, _a, geometry, address_components, place_id, formatted_address, main_text, secondary_text, selectedPlace;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, use_places_autocomplete_1.getGeocode({ address: address })];
            case 1:
                results = _b.sent();
                if (results.length) {
                    _a = results[0], geometry = _a.geometry, address_components = _a.address_components, place_id = _a.place_id, formatted_address = _a.formatted_address;
                    main_text = prediction
                        ? prediction.structured_formatting.main_text
                        : '';
                    secondary_text = prediction
                        ? prediction.structured_formatting.secondary_text
                        : '';
                    selectedPlace = {
                        geometry: geometry.viewport.toJSON(),
                        place_id: place_id,
                        formatted_address: formatted_address,
                        address_components: address_components.map(function (item) { return ({
                            long_name: item.long_name,
                            short_name: item.short_name,
                            types: item.types,
                        }); }),
                        main_text: main_text,
                        secondary_text: secondary_text,
                        center: {
                            lat: geometry.location.lat(),
                            lng: geometry.location.lng(),
                        },
                    };
                    return [2 /*return*/, {
                            selectedPlace: selectedPlace,
                            geometry: geometry,
                        }];
                }
                return [2 /*return*/];
        }
    });
}); };
exports.getAddressGeocode = getAddressGeocode;
var getLatLngCoordinates = function (coordinates) {
    return coordinates.filter(function (coordinate) { return [
        parseFloat(coordinate[1]),
        parseFloat(coordinate[0]),
    ]; });
};
exports.getLatLngCoordinates = getLatLngCoordinates;
var convertCoordinatesToLatLng = function (coordinates) {
    return coordinates.map(function (coordinate) { return ({
        lat: parseFloat(coordinate[1]),
        lng: parseFloat(coordinate[0]),
    }); });
};
exports.convertCoordinatesToLatLng = convertCoordinatesToLatLng;
var getIsContainsLocation = function (coordinates, location) {
    var polygon = new google.maps.Polygon({ paths: coordinates });
    var point = new google.maps.LatLng(__assign({}, location));
    return google.maps.geometry.poly.containsLocation(point, polygon);
};
exports.getIsContainsLocation = getIsContainsLocation;
var combineMissingDataToOnSelect = function (filteredData, placeDetails) {
    return __assign(__assign({}, filteredData), { address_components: placeDetails.address.map(function (item) { return ({
            long_name: item.localname,
            short_name: item.localname,
            types: [item.type],
        }); }), geometry: {
            south: Number(filteredData.boundingbox[0]),
            west: Number(filteredData.boundingbox[1]),
            east: Number(filteredData.boundingbox[2]),
            north: Number(filteredData.boundingbox[3]),
        }, place_id: String(filteredData.place_id), main_text: filteredData.display_name, formatted_address: filteredData.display_name, secondary_text: filteredData.display_name, center: {
            lat: placeDetails.centroid.coordinates[1],
            lng: placeDetails.centroid.coordinates[0],
        } });
};
exports.combineMissingDataToOnSelect = combineMissingDataToOnSelect;
